import styled from "styled-components";
import {blue, grey} from "../../constants/theme"

const Input = styled.input`
  outline: none;
  font-family: var(--font-family);
  border-radius: 8px;
  background: ${grey[900]};
  color: ${grey[300]};
  font-weight: 400;
  line-height: 1.5;
  padding: 0 16px;
  height: 48px;
  transition: all 0.1s ease;
  border: 1px solid ${grey[700]};
  box-sizing: border-box;
  font-size: 16px;
  
  &:hover {
    border-color: ${blue[400]};
  }

  &:focus {
    border-color: ${blue[400]};
  }
`

export default Input